import { action } from '@ember/object';
import SidebarBookingsController from 'uplisting-frontend/pods/-sidebar/bookings/controller';
import { animatedTransition } from 'uplisting-frontend/utils/router';

export default class ProtectionOverviewBookingsController extends SidebarBookingsController {
  @action
  handleClose(): void {
    animatedTransition(() => this.router.transitionTo('protection.overview'));
  }
}
